var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFaqs16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 61,
    stroke: "#339999",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.1118 87.6692C53.5145 87.6692 54.6516 86.5321 54.6516 85.1294C54.6516 83.7267 53.5145 82.5896 52.1118 82.5896C50.7091 82.5896 49.572 83.7267 49.572 85.1294C49.572 86.5321 50.7091 87.6692 52.1118 87.6692Z",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0497 87.6692C81.4524 87.6692 82.5895 86.5321 82.5895 85.1294C82.5895 83.7267 81.4524 82.5896 80.0497 82.5896C78.647 82.5896 77.5099 83.7267 77.5099 85.1294C77.5099 86.5321 78.647 87.6692 80.0497 87.6692Z",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 37H42.0796L48.8355 68.5443C49.0833 69.6996 49.7261 70.7323 50.6532 71.4647C51.5804 72.1972 52.7338 72.5835 53.9151 72.5572H78.7543C79.9104 72.5553 81.0312 72.1592 81.9317 71.4342C82.8321 70.7092 83.4584 69.6987 83.7069 68.5697L87.8976 49.699H44.7972",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFaqs16);
export default __webpack_public_path__ + "static/media/IconFaqs16.dd5d91cee4aa36f35b6be2867b2c90e7.svg";
export { ForwardRef as ReactComponent };